import { render, staticRenderFns } from "./accountDataInfo.vue?vue&type=template&id=6206a4d2&"
import script from "./accountDataInfo.vue?vue&type=script&lang=js&"
export * from "./accountDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./accountDataInfo.vue?vue&type=style&index=0&id=6206a4d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports